import React from 'react';
import PropTypes from 'prop-types';

const SingleLeftPanelItem = ({ item, isActive, onClick }) => {
    return (
        <button
            type='button'
            className={`single-left-panel-item ${isActive ? 'single-left-panel-item--active' : ''}`}
            onClick={onClick}
            aria-label={item.label}
            aria-current={isActive ? 'page' : undefined}
        >
            {item?.symbol ? <div className='single-left-panel-item-symbol'>{item.symbol}</div> : null}
            <div className='d-flex align-items-center justify-content-center'>
                <item.icon />
            </div>
            <div className='single-left-panel-item-label'>{item.label}</div>
        </button>
    );
};

SingleLeftPanelItem.propTypes = {
    item: PropTypes.shape({
        icon: PropTypes.elementType.isRequired,
        label: PropTypes.string.isRequired,
        symbol: PropTypes.node
    }).isRequired,
    isActive: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired
};

export default SingleLeftPanelItem;
